<div *ngIf="isReadOnly" class="readonly-message">
  {{ 'SIGNATURE.READONLY_MESSAGE' | translate }}
 </div>

 <div class="p-grid">
   <div class="p-col quality-assurance" *ngIf="fields$ | async as fields">
     <app-qa-check-list-in-setup
       [fields]="fields"
       [signatureConfig]="signatureConfig"
       [disabled]="isReadOnly"
       (formValid)="onFormValidityChange($event)"
    ></app-qa-check-list-in-setup>

    <div class="separator" *ngIf="qualityChecksElectronicSignature"></div>

    <div
      [ngClass]="isSigantureActive ? 'active-signature' : ''"
      *ngIf="qualityChecksElectronicSignature"
      class="signature-container">

      <app-signature
        [productionQaCheck]="fields"
        [disabled]="isReadOnly"
        (click)="setActiveSignature()"
      ></app-signature>
    </div>
   </div>
 </div>
